import { FormattedMessage } from 'react-intl';
import { PoweredByTbOneFooter } from 'components/PoweredByTbOneFooter';

export type ErrorAccountType = 'IGNORED' | 'TBMARKET' | 'NO_CHANNEL';

interface ErrorAccountPageProps {
  errorType: ErrorAccountType;
}

export function ErrorAccountPage({ errorType }: ErrorAccountPageProps) {
  const pageConfigurations = {
    IGNORED: {
      headlineId: 'error.ignored.account.header',
      paragraphOneId: 'error.ignored.account.paragraph.one',
      paragraphTwoId: 'error.ignored.account.paragraph.two',
    },
    TBMARKET: {
      headlineId: 'error.tbmarket.account.header',
      paragraphOneId: 'error.tbmarket.account.paragraph.one',
      paragraphTwoId: 'error.tbmarket.account.paragraph.two',
    },
    NO_CHANNEL: {
      headlineId: 'error.nochannel.account.header',
      paragraphOneId: 'error.nochannel.account.paragraph.one',
      paragraphTwoId: 'error.nochannel.account.paragraph.two',
    },
  };

  const activeConfig = pageConfigurations[errorType];

  return (
    <div className="flex flex-col block-list h-screen">
      <div style={{ maxWidth: 868 }} className="flex h-screen items-center mx-auto">
        <img className="block max-w-fit" src="/illustrations/ErrorForbidden.svg" alt="Access Forbidden" />

        <div className="py-10">
          <div className="block-list space-y-8 text-left">
            <p className="text-[26px] font-extrabold text-gray-900">
              <FormattedMessage id={activeConfig.headlineId} />
            </p>

            <p className="text-base text-gray-700">
              <FormattedMessage id={activeConfig.paragraphOneId} />
            </p>

            <p className="text-base text-gray-700">
              <FormattedMessage id={activeConfig.paragraphTwoId} />
            </p>
          </div>
        </div>
      </div>
      <div className="mt-auto">
        <PoweredByTbOneFooter />
      </div>
    </div>
  );
}
